<template>
  <footer>
    <div class="footer-content">
      <div class="footer-column" ref="aboutColumn">
        <h3>About DiOrion</h3>
        <p>The DiOrion Platform is a comprehensive suite of AI-powered tools designed to accelerate and transform drug discovery and development processes.</p>
        <p>Our mission is to empower drug hunters with cutting-edge technology to bring life-saving treatments to patients faster.</p>
      </div>
      <div class="footer-column" ref="contactColumn">
        <h3>Contact Us</h3>
        <ul class="contact-list">
          <li v-for="(contact, index) in contacts" :key="index" ref="contactItems">
            <i :class="contact.icon"></i> {{ contact.text }}
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="copyright" ref="copyright"> -->
      <!-- &copy; 2019-2025 PharmaResources DiOrion Team. All rights reserved. | Accelerating Drug Discovery Through AI -->
      <!-- Copyright &copy; 2024 All Rights Reserved by PharmaResources AIDD Group | Accelerating Drug Discovery Through AI -->
    <!-- </div> -->
     

    <!-- <div class="copyright" ref="copyright">
      <p class="copyright-main">
        &copy; 2019-2025 PharmaResources DiOrion Team. All rights reserved.
      </p>
      <div class="footer-legal" aria-label="备案信息">
      <p class="copyright-tagline">Accelerating Drug Discovery Through AI</p>
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >沪ICP备20013779号-4</a>
      </div>
    </div> -->


    <div class="copyright" ref="copyright">
      <p class="copyright-main">
        &copy; 2019-2025 PharmaResources DiOrion Team. All rights reserved.
      </p>
      <div class="footer-legal" aria-label="备案与站点说明">
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >沪ICP备20013779号-4</a>
        <span class="footer-legal-sep" aria-hidden="true">|</span>
        <a
          class="footer-beian-mps"
          href="https://beian.mps.gov.cn/#/query/webSearch?code=31011502406516"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="/beian-mps-icon.png"
            alt=""
            class="footer-beian-mps-icon"
          />
          沪公网安备31011502406516号
        </a>
        <span class="footer-legal-sep" aria-hidden="true">|</span>
        <span class="copyright-tagline">Accelerating Drug Discovery Through AI</span>
      </div>
    </div>

  </footer>
</template>

<script>
export default {
  data() {
    return {
      contacts: [
        { icon: "fas fa-phone", text: "Tel：+86-21-50720228-202" },
        { icon: "fas fa-envelope", text: "Business Info：sales@pharmaresources.cn" },
        { icon: "fas fa-globe", text: "https://www.pharmaresources.cn/" },
        { icon: "fas fa-map-marker-alt", text: "Address：Bldg. 12, No. 59 Kai Qing Rd, Pudong, Shanghai (West Campus)" }
      ]
    };
  },
  mounted() {
    this.setupScrollAnimations();
  },
  methods: {
    setupScrollAnimations() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            
            if (entry.target === this.$refs.contactColumn) {
              this.animateContactItems();
            }
          }
        });
      }, { threshold: 0.15 });

      observer.observe(this.$refs.aboutColumn);
      observer.observe(this.$refs.contactColumn);
      observer.observe(this.$refs.copyright);
    },
    animateContactItems() {
      this.$refs.contactItems.forEach((item, index) => {
        setTimeout(() => {
          item.classList.add('visible');
        }, 150 * index);
      });
    }
  }
};
</script>